<template>
  <div>
    <v-snackbar
      v-model="showNotification"
      :color="notificationColor"
      :timeout="timeout"
      top
      color="#f5365c"
    >
      {{ notificationText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="closeNotification"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WebSocketNotification",
  data() {
    return {
      showNotification: false,
      notificationText: "",
      notificationColor: "info",
      timeout: 5000,
      position: "bottom", // top, bottom, left, right
      currentNotification: null,
    };
  },

  computed: {
    ...mapGetters("websocket", ["unreadNotifications"]),
  },

  watch: {
    unreadNotifications(newNotifications) {
      if (newNotifications.length > 0 && !this.showNotification) {
        // Get the newest notification
        const notification = newNotifications[newNotifications.length - 1];
        this.displayNotification(notification);
      }
    },
  },

  methods: {
    displayNotification(notification) {
      this.currentNotification = notification;

      // Set notification properties based on type
      switch (notification.type) {
        case "alert":
          this.notificationColor = "error";
          this.timeout = 0; // No auto-close for alerts
          break;
        case "update":
          this.notificationColor = "success";
          this.timeout = 4000;
          break;
        case "notification":
        default:
          this.notificationColor = "info";
          this.timeout = 3000;
          break;
      }

      // Set notification text
      this.notificationText =
        notification.message ||
        notification.content ||
        JSON.stringify(notification);

      // Show notification
      this.showNotification = true;
    },

    closeNotification() {
      this.showNotification = false;

      // Mark notification as read
      if (this.currentNotification) {
        // You could dispatch an action to mark it as read in the store
        // this.$store.dispatch('websocket/markNotificationAsRead', this.currentNotification.id);
        this.currentNotification = null;
      }
    },
  },
};
</script>
